import React from 'react';
import { Alert, Box, Card, CardContent, Link, Stack, Typography } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { ActivityResponse } from 'us-web-services';

interface ActivityResultsCardProps {
  result: ActivityResponse;
}

const ActivityResultsCard: React.FC<ActivityResultsCardProps> = ({ result }) => (
  <Card>
    <CardContent>
      <Typography variant='h6' gutterBottom color={result.success ? 'success.main' : 'error.main'}>
        {result.success ? '✓ ' : '✗ '}
        {result.message}
      </Typography>

      {result.warnings.length > 0 && (
        <Alert severity='warning' sx={{ mb: 2 }}>
          {result.warnings.map((warning, idx) => (
            <div key={idx}>{warning}</div>
          ))}
        </Alert>
      )}

      <Stack spacing={1}>
        {result.activities.map((activity, idx) => (
          <Box
            key={activity.jobId ?? activity.bookingId ?? idx}
            sx={{
              p: 2,
              bgcolor: 'grey.50',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <CheckCircleIcon color='success' />
            <Box sx={{ flex: 1 }}>
              <Typography variant='body2'>
                <strong>Status:</strong> {activity.status}
              </Typography>
              {activity.jobId && (
                <Typography variant='body2'>
                  <strong>Job ID:</strong> {activity.jobId}
                  {activity.adminJobUrl && (
                    <Link href={activity.adminJobUrl} target='_blank' rel='noopener noreferrer' sx={{ ml: 1 }}>
                      View
                    </Link>
                  )}
                </Typography>
              )}
              {activity.bookingId && (
                <Typography variant='body2'>
                  <strong>Booking ID:</strong> {activity.bookingId}
                  {activity.adminBookingUrl && (
                    <Link href={activity.adminBookingUrl} target='_blank' rel='noopener noreferrer' sx={{ ml: 1 }}>
                      View
                    </Link>
                  )}
                </Typography>
              )}
              {activity.interestedSitterUserId && (
                <Typography variant='body2'>
                  <strong>Interested Sitter User ID:</strong> {activity.interestedSitterUserId}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Stack>
    </CardContent>
  </Card>
);

export default ActivityResultsCard;
